import { render, staticRenderFns } from "./RwSkedEdit.vue?vue&type=template&id=6d235bf8&scoped=true"
import script from "./RwSkedEdit.vue?vue&type=script&lang=ts"
export * from "./RwSkedEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d235bf8",
  null
  
)

export default component.exports